import { Navigate, Route, Routes } from "react-router-dom";
import { AppShell } from "./AppShell";
import { can, RequireUser } from "./auth";
import { SignInPage } from "../pages/SignIn";
import { OverviewPage } from "../pages/Overview";
import { RoadsPage } from "../pages/Roads";
import { RoadWorkspace } from "../pages/road/RoadWorkspace";
import { ReviewPage } from "../pages/Review";
import { DefectsPage } from "../pages/Defects";
import { SurveysPage, LiveSurveyPage } from "../pages/Surveys";
import { NetworkPage } from "../pages/Network";
import { ReportsPage } from "../pages/Reports";
import { AdminPage } from "../pages/admin/Admin";
import { EmptyState } from "../components/States";
import { FieldApp } from "../field/FieldApp";

export function App() {
  return (
    <Routes>
      <Route path="/sign-in" element={<SignInPage />} />
      <Route path="/field/*" element={<RequireUser allow={can.field}>{(me) => <FieldApp me={me} />}</RequireUser>} />
      <Route element={<RequireUser>{(me) => <AppShell me={me} />}</RequireUser>}>
        <Route index element={<RequireUser>{(me) => <OverviewPage me={me} />}</RequireUser>} />
        <Route path="roads" element={<RoadsPage />} />
        <Route path="roads/:surveyId/*" element={<RequireUser>{(me) => <RoadWorkspace me={me} />}</RequireUser>} />
        <Route path="review" element={<RequireUser allow={can.review}>{() => <ReviewPage />}</RequireUser>} />
        <Route path="review/:findingId" element={<RequireUser allow={can.review}>{() => <ReviewPage />}</RequireUser>} />
        <Route path="defects" element={<RequireUser>{(me) => <DefectsPage me={me} />}</RequireUser>} />
        <Route path="surveys" element={<RequireUser allow={can.field}>{() => <SurveysPage />}</RequireUser>} />
        <Route path="surveys/:surveyId/live" element={<RequireUser allow={can.field}>{() => <LiveSurveyPage />}</RequireUser>} />
        <Route path="network" element={<Navigate to="/network/condition" replace />} />
        <Route path="network/:lens" element={<NetworkPage />} />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="admin/*" element={<RequireUser allow={can.admin}>{(me) => <AdminPage me={me} />}</RequireUser>} />
        <Route path="*" element={<EmptyState title="Page not found" action={<a className="btn" href="/">Go to Overview</a>}>The address may be mistyped or the page has moved.</EmptyState>} />
      </Route>
    </Routes>
  );
}
